import * as Yup from "yup";
import { Roles } from "src/@types/users";
import {
  WEBSITE_LINK_VALIDATION_SCHEMA,
  FIRST_NAME_VALIDATION_SCHEMA,
  MAX_LENGTH_VALIDATION,
  LAST_NAME_VALIDATION_SCHEMA,
  NOT_EMPTY_ARRAY_VALIDATION,
  PHONE_VALIDATION_SCHEMA,
  EMAIL_VALIDATION_SCHEMA,
  PASSWORD_VALIDATION_SCHEMA,
  VALIDATE_FILES_SIZE_AND_COUNT,
} from "src/constants/formValidation";
import { RegistrationFields } from "../types";

export const REGISTRATION_VALIDATION_SCHEMA = Yup.object().shape({
  [RegistrationFields.role]: Yup.string().required("required"),
  [RegistrationFields.country]: Yup.string().required("required"),
  [RegistrationFields.companyName]: Yup.string().required("required"),
  [RegistrationFields.companyAddress]: Yup.string().required("required"), // CHANGE - temp (need real validation for legalAddress)
  [RegistrationFields.website]:
    WEBSITE_LINK_VALIDATION_SCHEMA.required("required"),
  [RegistrationFields.firstName]: FIRST_NAME_VALIDATION_SCHEMA,
  [RegistrationFields.description]: MAX_LENGTH_VALIDATION(2000),
  [RegistrationFields.lastName]: LAST_NAME_VALIDATION_SCHEMA,

  [RegistrationFields.industry]: Yup.string().when(RegistrationFields.role, {
    is: Roles.OWNER,
    then: () => Yup.string().required("required"),
    otherwise: () => Yup.string().optional(),
  }),

  [RegistrationFields.international]: Yup.boolean().when(
    RegistrationFields.role,
    {
      is: Roles.OWNER,
      then: () => Yup.boolean().required("required"),
      otherwise: () => Yup.boolean().optional(),
    }
  ),

  [RegistrationFields.reprecentionCountries]: Yup.array().when(
    RegistrationFields.role,
    {
      is: Roles.OWNER,
      then: () => NOT_EMPTY_ARRAY_VALIDATION,
      otherwise: () => Yup.array().optional(),
    }
  ),

  [RegistrationFields.foundingDocs]: Yup.mixed().when(RegistrationFields.role, {
    is: Roles.OWNER,
    then: () => Yup.mixed().optional(),
    otherwise: () => VALIDATE_FILES_SIZE_AND_COUNT(20, 5),
  }),

  [RegistrationFields.phoneNumber]: PHONE_VALIDATION_SCHEMA,
  [RegistrationFields.email]: EMAIL_VALIDATION_SCHEMA,
  [RegistrationFields.password]: PASSWORD_VALIDATION_SCHEMA,
});
